module.exports = __webpack_public_path__ + "img/information-icon.aaa94f83.svg";